export {
  buildSharedResourceScopeMenuItems,
  canManageSharedResource,
  hasSharedResourceCapability,
  normalizeSharedResourceScopeQuery,
  readSharedResourceScopeFromQuery,
  replaceSharedResourceScopeQuery,
  SHARED_RESOURCE_SCOPE_VALUES,
  type SharedResourceScope,
} from "@airange/shared";
